import {Switch} from '@wandb/weave/components';
import React, {useState} from 'react';

import {useVideoPlaybackSyncSettings} from '../../hooks/useVideoPlaybackSyncSettings';
import {SettingTitle} from '../common/SettingTitle';
import {
  useMediaSettingsDrawerContext,
  useWorkspaceMediaSettingsDrawer,
} from '../MediaSettingsDrawerContextProvider';

export const VideoPlaybackSyncAutoplay = () => {
  const {config, updateConfig, unsetConfigField, settingsLevel} =
    useMediaSettingsDrawerContext();
  const {
    isEnabled: isEnabledVideoPlaybackSync,
    isInherited: isInheritedVideoPlaybackSync,
    autoPlay: {isEnabled: isEnabledAutoPlay},
  } = useVideoPlaybackSyncSettings(config, settingsLevel);
  const {
    updateConfig: updateWorkspaceConfig,
    unsetConfigField: unsetWorkspaceConfigField,
  } = useWorkspaceMediaSettingsDrawer();

  const [shouldSyncVideoPlaybackAutoplay, setShouldSyncVideoPlaybackAutoplay] =
    useState(isEnabledAutoPlay);

  if (isInheritedVideoPlaybackSync || !isEnabledVideoPlaybackSync) {
    return null;
  }
  return (
    <div className={'flex justify-between gap-24'}>
      <SettingTitle
        title="Autoplay videos"
        description="Automatically start playing videos when entering the workspace or opening a panel."
        configField="videoPlaybackSyncAutoplay"
      />
      <Switch.Root
        aria-label="Toggle video playback autoplay"
        data-test="sync-video-playback-autoplay-switch"
        checked={shouldSyncVideoPlaybackAutoplay}
        onCheckedChange={newValue => {
          setShouldSyncVideoPlaybackAutoplay(newValue);
          // Allow the switch to animate before updating the config so that it's more of a smooth
          // transition before the component re-mounts
          setTimeout(() => {
            if (newValue) {
              updateConfig({videoPlaybackSyncAutoplay: newValue});
              if (settingsLevel !== 'workspace') {
                updateWorkspaceConfig({videoPlaybackSyncAutoplay: newValue});
              }
            } else {
              unsetConfigField('videoPlaybackSyncAutoplay');
              if (settingsLevel !== 'workspace') {
                unsetWorkspaceConfigField('videoPlaybackSyncAutoplay');
              }
            }
          }, 100);
        }}>
        <Switch.Thumb checked={shouldSyncVideoPlaybackAutoplay ?? false} />
      </Switch.Root>
    </div>
  );
};
